var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"plain-button tw-font-light"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',{class:_vm.isOpen ? 'reverse-rotate' : 'direct-rotate',attrs:{"color":"#8a8a8a"}},[_vm._v("mdi-chevron-down")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }